import { render, staticRenderFns } from "./ButtonExportExcel.vue?vue&type=template&id=0bf04442&scoped=true&"
import script from "./ButtonExportExcel.vue?vue&type=script&lang=js&"
export * from "./ButtonExportExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf04442",
  null
  
)

export default component.exports